'use strict';

var SaveExclusionsPopupDirective = function SaveExclusionsPopupDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'SaveExclusionsPopupController',
    template: require('../templates/save-exclusions-popup.html'),
    scope: {
      quickFilterData: '=',
      modifiedBars: '='
    }
  };
};
module.exports = SaveExclusionsPopupDirective;